(function(win) {
  'use strict';

  var listeners = [],
  doc = win.document,
  MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
  observer;

  function ready(selector, fn) {
      listeners.push({
          selector: selector,
          fn: fn
      });
      if (!observer) {
          // Watch for changes in the document
          observer = new MutationObserver(check);
          observer.observe(doc.documentElement, {
              childList: true,
              subtree: true
          });
      }
      // Check if the element is currently in the DOM
      check();
  }

  function check() {
      // Check the DOM for elements matching a stored selector
      for (var i = 0, len = listeners.length, listener, elements; i < len; i++) {
          listener = listeners[i];
          // Query for elements matching the specified selector
          elements = doc.querySelectorAll(listener.selector);
          for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
              element = elements[j];
              // Make sure the callback isn't invoked with the
              // same element more than once
              if (!element.ready) {
                  element.ready = true;
                  // Invoke the callback with the element
                  listener.fn.call(element, element);
              }
          }
      }
  }

  // Expose `ready`
  win.ready = ready;

})(this);


// Touch

var body = document.getElementsByTagName('body')[0];
if ( !("ontouchstart" in body) ) {
    body.className += (body.className?" ":"") + "no-touch";
} else {
    body.className += (body.className?" ":"") + "has-touch";
}


// Menu hover
/* */
if ( !("ontouchstart" in body) ) {
  let items = document.querySelector(".list-menu--inline").querySelectorAll("details");
  items.forEach(item => {
    item.addEventListener("mouseover", () => {

      const myTimeout = setTimeout(hover, 80);

      function hover() {

        item.setAttribute("open", true);
        item.querySelector(".header__subdropdown").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });

      }

      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
        clearTimeout(myTimeout);
      });

    });
  });
}


// Menu Expand
/*
document.querySelectorAll(".header__subdropdown > div > ul > li").forEach(function(element){
  element.addEventListener("click", function(event){

    //console.log('test')

    document.querySelectorAll(".header__subdropdown > div > ul > li details").forEach(function(element){
      element.removeAttribute("open");
    });

  });
});
*/

// Homepage Tabs

var tabBtns = document.querySelector('.tab-btns');

if ( tabBtns ){
  document.querySelectorAll(".tab-btns span").forEach(function(element){
    element.addEventListener("click", function(event){

      document.querySelectorAll(".tab-btns span").forEach(function(element){
        element.classList.remove("active");
      });

      element.classList.add("active");

      var name = element.textContent.trim();

      document.querySelectorAll(".featured-collection-slider").forEach(function(element){
        element.style.display = "none";
      });
      document.querySelector("[data-featured='"+name+"']").style.display = "block";

    });
  });
}


// USP Slider

var uspSlider = document.querySelector('.usp-bar-wrapper');
if ( uspSlider ){
  var flkty = new Flickity( uspSlider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pageDots: false,
    prevNextButtons: false,
    autoPlay: 3000,
    watchCSS: true,
    pauseAutoPlayOnHover: false
  });
}


// Related Slider

ready('#related-product-grid .grid__item', function(element) {
  var relatedSlider = document.getElementById('related-product-grid');
  if ( relatedSlider ){
    var flkty = new Flickity( relatedSlider, {
      // options
      groupCells: true,
      cellAlign: 'left',
      contain: true,
      wrapAround: false,
      pageDots: false,
      pauseAutoPlayOnHover: false
    });
  }
});


// Landing Product Slider

var productSlider = document.querySelector('.page-products .grid');
if ( productSlider ){
  var flkty = new Flickity( productSlider, {
    // options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    pageDots: false,
    autoPlay: false,
    pauseAutoPlayOnHover: false
  });
}

